import script from "./ingredient-meta-list-search.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-meta-list-search.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__